export default function About() {
  const stats = [
    { number: '00+', label: 'CLIENTS' },
    { number: '2.5M+', label: 'LEADS GENERATED' },
    { number: '98%', label: 'RETENTION RATE' }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1300px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/c1d9590a82ec87a00b545f70b7d9cef6.jpg"
                alt="Escobar Marketing Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-28 h-28 bg-[#FF6B35] rounded-full flex items-center justify-center shadow-xl">
              <div className="text-center">
                <p className="text-white font-bold text-lg">Est.</p>
                <p className="text-white font-bold text-2xl">2026</p>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:pl-12">
            <p className="text-[#FF6B35] text-sm font-semibold tracking-[0.2em] uppercase mb-4">
              ABOUT ESCOBAR MARKETING
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-10">
              We Build Marketing Systems That Generate Predictable Growth
            </h2>

            <div className="space-y-6 mb-12">
              <p className="text-gray-600 text-lg leading-relaxed">
                Escobar Marketing was founded with one mission: to help businesses grow sustainably through strategic, data-driven marketing. We're not here to sell you services you don't need—we're here to build systems that work.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                Our focus is on real business growth, not vanity metrics. Every campaign, every strategy, and every decision is made with your bottom line in mind. We measure success by revenue generated, leads converted, and long-term partnerships built.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
